/** The app page's Repository card (api/openapi.yaml `/apps/{appId}/source`): pure decisions, tested on their own. */
import type { AppFramework, AppSource, AppSourceRequest } from '@hangar/shared';

/** Expo and React Native apps: Hangar's runner fetches their repository for Run build. Native apps link through their build setup ("Create on Bitrise"). */
export const showsRepositoryCard = (framework: AppFramework): boolean => framework === 'expo' || framework === 'react_native';

/** The body of `PUT /apps/{id}/source`, or null until a connection and a repository are picked. */
export function linkBody(connection: { id: string } | undefined, repository: string): AppSourceRequest | null {
  const slug = repository.trim();
  return connection && slug ? { scmConnectionId: connection.id, repository: slug } : null;
}

export const ORIGIN_LABEL: Record<AppSource['origin'], string> = { app: 'Linked here', bitrise_setup: 'Linked by the build setup' };

/** What the card says about Run build: what the runner fetches, or why it cannot. */
export function runnerLine(source: AppSource | null | undefined): string {
  if (!source) return 'Not linked: Run build of this app is blocked until its repository is linked. Builds from your CI (hangar build) are not affected.';
  return `Run build fetches ${source.fullName} at the commit you pick and sends it to Hangar's build service. Protected environments build the branch head Hangar verifies here.`;
}

/** Whether the card offers Unlink (a "Create on Bitrise" link belongs to that setup). */
export const canUnlink = (source: AppSource | null | undefined): boolean => source?.origin === 'app';
